<template>
    <div class="md-grid">
        <Tabs
            :headers="tabs.map(v => v.title)"
            :activeTab="activeTab"
            @change="setTab"
            :full="false"
        />
        <div class="tabs">
            <slot
                class="tab"
                :name="tabs[activeTab].component"
            />
        </div>
    </div>
</template>

<script>
import Tabs from './Tabs';

export default {
    name: 'MDGrid',
    data: ()=>({
        activeTab: 0,
        tabs: [
            {
                title: 'Ваша цель',
                component: 'Profession',
            },
            {
                title: 'Необходимо освоить',
                component: 'Competences',
            },
            {
                title: 'Трек развития',
                component: 'Timeline',
            },
            {
                title: 'Необходимо запланировать',
                component: 'Bucket',
            },
        ],
    }),
    components: {
        Tabs,
    },
    methods: {
        setTab(index){
            this.activeTab = index;
        },
    },
};
</script>

<style lang="scss" scoped>
    .tabs{
        width: 100%;
        min-height: 80vh;
        height: 80vh;
        padding: 32px;
    }
</style>
